export default __webpack_public_path__ + "static/media/lymphdema-therapy.ef88e348.svg";